export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/ads_social_media_videos.0772a8c.svg";